import React from 'react';
import {Menu} from "antd";
import {Link, useLocation} from "react-router-dom";

const items = [
    {
        label: <Link to='report'>Обзор</Link>,
        key: 'report',
    },
    {
        label:
            <Link to='assets'>Счета</Link>,
        key: 'assets',
    },
    {
        label:
            <Link to='transactions'>Сделки</Link>,
        key: 'transactions',
    },
    {
        label:
            <Link to='trading'>Торговля</Link>,
        key: 'trading',
        children: [
            {
                key: 'trading/settings',
                label: <Link to='trading/settings'>Настройки</Link>
            },
            {
                key: 'trading/signals',
                label: <Link to='trading/signals'>Сигналы</Link>
            },
        ],
    },
]

const PortfolioSider = () => {
    const location = useLocation();

    const getSelectedKeys = () => {
        const path = location.pathname;
        const relativePath = path.replace('/app/portfolio/', '');

        // Для путей типа trading/settings
        if (relativePath.startsWith('trading/')) {
            return [relativePath]; // вернет 'trading/settings' или 'trading/signals'
        }

        return [relativePath || 'report'];
    };

    const getOpenKeys = () => {
        if (location.pathname.includes('trading')) {
            return ['trading'];
        }
        return [];
    };



    return(
        <Menu items={items}
              mode="inline"
              selectedKeys={getSelectedKeys()}
              defaultOpenKeys={getOpenKeys()}
        />
    )
}

export default PortfolioSider;
